import GetAppIcon from '@material-ui/icons/GetApp';

const PdfDownload = ({ fileUrl }) => {
    return <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: 'white', }}><h1 style={{ paddingRight: '20px' }}>
        You can download this pdf for future reference
    </h1>  <a style={{ margin: 'auto 0', cursor: 'pointer' }} href={fileUrl} download><GetAppIcon style={{ cursor: 'pointer' }} fontSize='large' /></a></div>
}


export default PdfDownload;